import {Close} from '@mui/icons-material';
import {Box, Dialog, DialogContent, DialogTitle, IconButton, Paper, Typography} from '@mui/material';
import MarkdownContentRenderer from '../atoms/MarkdownContentRenderer/MarkdownContentRenderer';
import RenderedHint from '../atoms/RenderedHint/RenderedHint';
import BondGraphRenderer from '../bonds/bondGraphRenderer/BondGraphRenderer';

interface HintDialogProps {
  open: boolean;
  onClose: () => void;
  hint: string | null | undefined;
  questionText: string;
  graphJsonString?: string | null | undefined;
}

export default function HintDialog({open, onClose, hint, questionText, graphJsonString}: HintDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: '300px',
        },
      }}
    >
      <DialogTitle sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1}}>
        <Typography component="span" variant="h6" sx={{fontWeight: 600}}>
          Hint
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{color: 'text.secondary'}}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{pt: 0}}>
        <Box sx={{mb: 3}}>
          <Typography variant="body2" color="text.secondary" sx={{mb: 1, fontWeight: 500}}>
            Question:
          </Typography>
          <Paper sx={{p: 2, bgcolor: 'grey.50', border: '1px solid', borderColor: 'grey.200'}}>
            <BondGraphRenderer graphJsonString={graphJsonString} height={200} />
            <MarkdownContentRenderer content={questionText} />
          </Paper>
        </Box>

        {hint && <RenderedHint hint={hint} />}
        {!hint && (
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{mb: 1, fontWeight: 500}}>
              Hint:
            </Typography>
            <Paper sx={{p: 2, bgcolor: 'primary.50', border: '1px solid', borderColor: 'primary.200'}}>
              <MarkdownContentRenderer content="No hint available for this question." />
            </Paper>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
